import React from "react";
import Dashboard from "./components/Dashboard";

function App() {
  // Assuming access_token is always present
  return <Dashboard />;
}

export default App;